import { useEffect } from "react"
import { useAtomValue } from "jotai"
import { dialogsAtom } from "@/store/dialogs-state"

export const DialogInert = ({ children }: { children: React.ReactNode }) => {
	const dialogs = useAtomValue(dialogsAtom)
	const hasDialogs = dialogs && dialogs.length > 0

	useEffect(() => {
		if (hasDialogs || typeof document === "undefined") {
			return
		}

		// Radix can occasionally leave pointer-events on body/html after abrupt unmounts.
		document.body.style.removeProperty("pointer-events")
		document.documentElement.style.removeProperty("pointer-events")
	}, [hasDialogs])

	return (
		<div className="contents" inert={hasDialogs ? true : undefined}>
			{children}
		</div>
	)
}
